export default __webpack_public_path__ + "media/images/tenant/chooseTabas/reason_2-69c994c861cb70b6aeef5d269e327155.webp";